import ClockoutController from '../../core/clockout.controller';
import Inherit from '../../core/inherit';
import AccountDelegate from './account.delegate';

/**
 * @extends ClockoutController
 * @extends AccountDelegate
 */
class AccountController extends Inherit(ClockoutController, AccountDelegate) {
    state = {
        user: {},
        loading: true,
        firstName: '',
        lastName: '',
        email: '',
        phoneNumber: '',
        currentPassword: '',
        newPassword: '',
        confirmPassword: '',
        showPasswordSection: false,
        saving: false,
        error: false,
        successMessage: ''
    };

    async initialize() {
        // Check if user has valid data
        if (!this.user || !this.user.access || this.user.access.length === 0) {
            this.navigateLogin();
            return;
        }

        // Load user data into form
        const user = this.data.user;
        this.setState({ 
            user,
            firstName: user?.name?.split(' ')[0] || '',
            lastName: user?.name?.split(' ').slice(1).join(' ') || '',
            email: user?.email || '',
            phoneNumber: user?.phone || '',
            loading: false 
        });
    }

    async cleanup() {
        // Cleanup if needed
    }

    async handleSaveChanges() {
        try {
            this.setState({ saving: true, error: false, successMessage: '' });

            const { firstName, lastName, email, phoneNumber, currentPassword, newPassword, confirmPassword, showPasswordSection } = this.state;
            const user = this.data.user;

            // Validate password change if section is open
            if (showPasswordSection) {
                if (!currentPassword) {
                    this.setState({ error: true, saving: false });
                    alert('Please enter your current password');
                    return;
                }

                if (newPassword !== confirmPassword) {
                    this.setState({ error: true, saving: false });
                    alert('New passwords do not match');
                    return;
                }

                if (newPassword.length < 8) {
                    this.setState({ error: true, saving: false });
                    alert('New password must be at least 8 characters');
                    return;
                }

                // Update password separately
                const passwordResponse = await this.data.updatePassword({
                    email,
                    password: newPassword,
                    current_password: currentPassword
                });

                if (!passwordResponse?.success) {
                    throw new Error(passwordResponse?.message || 'Failed to update password');
                }
            }

            // Check if there are any account changes
            const currentFullName = `${firstName} ${lastName}`.trim();
            const originalFullName = user?.name || '';
            const hasAccountChanges = 
                currentFullName !== originalFullName ||
                email !== (user?.email || '') ||
                phoneNumber !== (user?.phone || '');

            // Only call updateAccount if there are changes
            if (hasAccountChanges) {
                const updateData = {
                    name: currentFullName,
                    email,
                    phone: phoneNumber
                };

                const response = await this.data.updateAccount(updateData);

                if (!response?.success) {
                    throw new Error(response?.message || 'Failed to update account');
                }

                // Update user data in controller
                this.constructor._notifyAuthChange();
            }

            // Show success animation
            this.setState({ 
                saving: false, 
                successMessage: 'Account updated successfully',
                showPasswordSection: false,
                currentPassword: '',
                newPassword: '',
                confirmPassword: ''
            });

            // Navigate to dashboard after animation
            setTimeout(() => {
                this.navigateDashboard();
            }, 2000);

        } catch (error) {
            console.error('Error updating account:', error);
            this.setState({ 
                error: true, 
                saving: false,
                successMessage: ''
            });
            alert(error.message || 'Failed to update account. Please try again.');
        }
    }

    handleCancel() {
        this.navigateDashboard();
    }
}

export default AccountController;

